import React from "react";
import networkError from "assets/img/network.svg";
import { Button } from "@windmill/react-ui";

const NetworkError = () => {
  return (
    <div className="flex flex-col items-center justify-center p-5 pt-8">
      <img
        className="my-4"
        src={networkError}
        alt="somethingWrong"
        style={{ maxWidth: "200px", width: "80%" }}
      />
      <h2 className="text-lg md:text-xl lg:text-2xl xl:text-2xl text-center mt-2 font-medium font-serif text-gray-600">
        Please Check internet connection
        <span role="img" aria-labelledby="img"></span>
      </h2>
      <Button
        onClick={() => window.location.reload()}
        className="mb-6 mt-2 px-4 py-2 border-2 border-black text-black rounded bg-white"
        style={{ backgroundColor: "white" }}
      >
        Retry
      </Button>
    </div>
  );
};

export default NetworkError;
